export const FERADEL_LOGO_PATH = "https://www.feradel.com/wp-content/uploads/2025/02/Feradel-Logox96h.png";
